/**
 * Prepare Specialist Finder data for the future contact modal.
 *
 * The modal can subscribe to the `lecardo-vein:specialist-finder:submit`
 * document event and read the selected symptoms from `event.detail`.
 *
 * @return {void}
 */
export function initSpecialistFinder() {
	const forms = document.querySelectorAll('[data-specialist-finder-form]');

	forms.forEach((form) => {
		const symptomError = form.querySelector(
			'[data-specialist-finder-symptom-error]'
		);
		const consentError = form.querySelector(
			'[data-specialist-finder-consent-error]'
		);

		const setError = (element, message) => {
			if (!element) {
				return;
			}

			element.textContent = message;
			element.hidden = !message;
		};

		const clearErrors = () => {
			setError(symptomError, '');
			setError(consentError, '');
		};

		form.addEventListener('change', (event) => {
			const input = event.target;

			if (
				input.matches('input[name="symptoms[]"]') &&
				form.querySelector('input[name="symptoms[]"]:checked')
			) {
				setError(symptomError, '');
			}

			if (input.matches('input[name="consent"]') && input.checked) {
				setError(consentError, '');
			}
		});

		form.addEventListener('submit', (event) => {
			event.preventDefault();

			const selectedInputs = Array.from(
				form.querySelectorAll('input[name="symptoms[]"]:checked')
			);
			const consent = form.querySelector('input[name="consent"]');

			if (consent && !consent.checked) {
				setError(symptomError, '');
				setError(
					consentError,
					form.dataset.consentError ||
						'Consent to personal data processing is required.'
				);
				consent?.focus();
				return;
			}

			clearErrors();

			const detail = {
				symptoms: selectedInputs.map((input) => ({
					slug: input.value,
					label: input.dataset.label || input.value,
				})),
				consent: consent ? consent.checked : false,
				source: 'front-page-specialist-finder',
			};

			form.dispatchEvent(
				new CustomEvent('lecardo-vein:specialist-finder:submit', {
					bubbles: true,
					detail,
				})
			);
		});
	});
}
